export default "__VITE_ASSET__r$7SdCbL__"